import { SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { fontStyles } from '@/styles/typography';

export function LiquiditySourcesHero() {
  return (
    <header
      className="mx-0 desktop:mx-[104px] pb-24 mt-[152px] grid relative bg-center bg-no-repeat"
      style={{
        backgroundImage: 'url(/images/liquidity-sources/liquidity-sources-hero.png)',
        backgroundSize: 'auto 530px',
      }}
    >
      <div
        className="pt-24 pb-12 mx-auto z-10 px-10 tablet:px-[84px] w-full"
        style={{
          background:
            'radial-gradient(80.36% 67.99% at 50.6% 56.9%, #FFF 0%, #FFF 29.69%, rgba(255, 255, 255, 0.64) 62.5%, rgba(255, 255, 255, 0.00) 100%)',
        }}
      >
        <h4
          className={fontStyles({
            variant: 'H2',
            class: ['text-center', 'text-500', 'leading-[3.5rem]'],
          })}
          style={{
            WebkitTextFillColor: 'transparent',
            background:
              'linear-gradient(rgba(2, 168, 99, 1), rgba(2, 168, 99, 0.49)), linear-gradient(rgba(118, 182, 36, 1), rgba(36, 182, 77, 0))',
            backgroundClip: 'text',
          }}
        >
          More than 130+
        </h4>
        <h1
          className={fontStyles({
            variant: 'H1',
            class: [
              'text-[2.875rem]',
              'tablet:text-[4rem]',
              'leading-[3rem]',
              'tablet:leading-[5rem]',
              'text-center',
              'grid',
              'mb-6',
            ],
          })}
        >
          Liquidity sources
        </h1>
        <p
          className={fontStyles({
            variant: 'BODY_LG',
            class: ['text-token-gray-800', 'text-center', 'grid', 'mx-auto', 'max-w-[500px]'],
          })}
        >
          Deep liquidity for the best prices on 9+ million tokens across{' '}
          {SUPPORTED_CHAIN_IDS.length} chains. Tap into 130+ liquidity sources aggregated by Matcha!
        </p>
      </div>
    </header>
  );
}
